module.exports = __webpack_public_path__ + "static/media/maxally-icon.4554102b.svg";